import api from "./api";

export const updateAccount = async (account) => {
    try {
        const response = await api.put('/accounts', account);
        if (response.status === 200) return response.data;
        return false;
    } catch (error) {
        console.error("Error updating account:", error);
        return false;
    }
}

export const getAccount = async (accountId, yearMonth) => {
    try {
        const query = yearMonth ? `?yearMonth=${encodeURIComponent(yearMonth)}` : '';
        const response = await api.get(`/accounts/${accountId}${query}`);
        if (response.status === 200) return response.data;
        return false;
    } catch (error) {
        console.error("Error fetching account:", error);
        return false;
    }
}